"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var __1 = require("../../../../..");
var hooks_1 = require("../../../../../hooks");
var Field_1 = __importDefault(require("../../../components/Field"));
var Label_1 = __importDefault(require("../../../components/Label"));
var Dropdown_1 = __importDefault(require("../../../inputs/Dropdown"));
var mapToOptions = ramda_1.map(function (typAdresy) { return ({ value: typAdresy.id, label: typAdresy.nazev }); });
var SelectTypAdresy = function (_a) {
    var name = _a.name, label = _a.label, filterResult = _a.filterResult, size = _a.size, readOnly = _a.readOnly, enableReset = _a.enableReset;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var _c = hooks_1.useCiselnik('typyAdres'), data = _c.data, error = _c.error, loading = _c.loading;
    var typyAdres = filterResult ? (data || []).filter(filterResult) : data || [];
    if (typyAdres.length === 1 && field.value !== typyAdres[0].id) {
        helpers.setValue(typyAdres[0].id);
    }
    return (react_1.default.createElement(Field_1.default, { loading: loading, error: error },
        react_1.default.createElement(Label_1.default, { htmlFor: __1.NormalizeString(label) }, label),
        react_1.default.createElement(Dropdown_1.default, { enableReset: enableReset, size: size, hasError: !!meta.error, placeholder: "Vyberte typ adresy", name: "idTypAdresy", value: field.value, onChange: function (v) { return helpers.setValue(v); }, loadOptions: function () { return Promise.resolve(mapToOptions(typyAdres)); }, readOnly: readOnly, inputId: __1.NormalizeString(label) })));
};
SelectTypAdresy.defaultProps = {
    filterResult: undefined,
    size: undefined,
    readOnly: false,
    enableReset: false,
};
exports.default = SelectTypAdresy;
